import { BaseService } from "./BaseService";

export enum ServiceNames {
  Applications = "Applications",
  Clients = "Clients",
  Agents = "Agents",
  Opportunities = "Opportunities",
  OpportunityStatus = "OpportunityStatus",
  Upload = "Upload",
  OpportunityAttachment = "OpportunityAttachment",
}

abstract class BaseDocumentService<T> extends BaseService {
  abstract serviceName: ServiceNames;

  async get(id: string): Promise<T> {
    const results = await this.client.get<T>(`/api/${this.serviceName}/${id}`);
    return results.data;
  }

  async getByClientId(id:string): Promise<T[]> {
    const results = await this.client.get<T[]>(`/api/${this.serviceName}/client/${id}`);
    return results.data;
  }

  async save(data: T): Promise<T> {
    const results = await this.client.post<T>(`/api/${this.serviceName}`, data);
    return results.data;
  }

}

export abstract class BaseParentDocumentService<T> extends BaseDocumentService<
  T
> {
  async getAll(): Promise<T[]> {
    const results = await this.client.get<T[]>(`/api/${this.serviceName}`);
    return results.data;
  }
}

export abstract class BaseChildDocumentService<T> extends BaseDocumentService<
  T
> {
  async getAll(parentId: string): Promise<T[]> {
    const results = await this.client.get<T[]>(
      `/api/${this.serviceName}/${parentId}/`,
    );
    return results.data;
  }
}
